
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("7S9uM", function(module, exports) {

var $gw4Eo = parcelRequire("gw4Eo");

const $4578b5a9386fb739$export$7159abb8d1b3a2ba = (eventName)=>`avi:confluence:${eventName}`;
const $4578b5a9386fb739$export$c08b254487aa335f = (resourceId)=>{
    if (Array.isArray(resourceId)) return resourceId;
    else return [
        resourceId
    ];
};
const $4578b5a9386fb739$export$2bf1e957d474f961 = (client)=>{
    return client?.currentProtocol?.getType();
};
class $4578b5a9386fb739$export$7f942edeee9c7437 {
    /**
   * @param {object} client
   * @param {string} cloudId
   * @param {string} activationId
   */ constructor(client, cloudId, activationId){
        this.client = void 0;
        this.cloudId = void 0;
        this.activationId = void 0;
        /**
     * Join a channel
     * @param {array|string} resourceType - string represents the type of resource: page, comment, blogpost, space
     * @param {array|string} resourceId - multiple or a resource id
     */ this.joinChannel = async (resourceType, resourceId)=>{
            const resourceIds = $4578b5a9386fb739$export$c08b254487aa335f(resourceId);
            const aris = resourceIds.map((id)=>(0, $gw4Eo.getConfluenceContentAri)({
                    siteId: this.cloudId,
                    resourceType: resourceType,
                    activationId: this.activationId,
                    resourceId: id
                }));
            return this.client.join(aris).catch((error)=>{
                throw new Error(`PubSub Web Client (${$4578b5a9386fb739$export$2bf1e957d474f961(this.client)}) joinChannel
        ${JSON.stringify(error, Object.getOwnPropertyNames(error))} aris: ${aris}`);
            });
        };
        /**
     * Leave a channel
     * @param {array|string} resourceId - multiple or a resource id
     */ this.leaveChannel = async (resourceType, resourceId)=>{
            const resourceIds = $4578b5a9386fb739$export$c08b254487aa335f(resourceId);
            const aris = resourceIds.map((id)=>(0, $gw4Eo.getConfluenceContentAri)({
                    siteId: this.cloudId,
                    resourceType: resourceType,
                    activationId: this.activationId,
                    resourceId: id
                }));
            return this.client.leave(aris).catch((error)=>{
                throw new Error(`PubSub Web Client (${$4578b5a9386fb739$export$2bf1e957d474f961(this.client)}) leaveChannel
        ${JSON.stringify(error, Object.getOwnPropertyNames(error))} aris: ${aris}`);
            });
        };
        /**
     * Subscribe to an event being broadcast in channel
     * @param {array|string} eventName - name of event to subscribe to
     */ this.subscribe = async (eventName, cb)=>{
            return this.subscribeSync(eventName, cb);
        };
        this.subscribeSync = (eventName, cb)=>{
            return this.client.on(eventName, cb);
        };
        /**
     * Unsubscribe from an event being broadcast in channel
     * @param {array|string} eventName - name of event to subscribe to
     */ this.unsubscribe = async (eventName, cb)=>{
            return this.unsubscribeSync(eventName, cb);
        };
        this.unsubscribeSync = (eventName, cb)=>{
            return this.client.off(eventName, cb);
        };
        this.client = client;
        this.cloudId = cloudId;
        this.activationId = activationId;
    }
}
module.exports["eventToAvi"] = $4578b5a9386fb739$export$7159abb8d1b3a2ba;
module.exports["getCurrentProtocolType"] = $4578b5a9386fb739$export$2bf1e957d474f961;
module.exports["PubSubClient"] = $4578b5a9386fb739$export$7f942edeee9c7437;

});

parcelRegister("gRrX4", function(module, exports) {

var $ge2sX = parcelRequire("ge2sX");


var $04e9M = parcelRequire("04e9M");


var $7S9uM = parcelRequire("7S9uM");

const $25943768104c0291$var$CONFLUENCE_PRODUCT_KEY = 'CONFLUENCE';
// Where the pubsub service lives
const $25943768104c0291$var$PUBSUB_HOST = '/gateway/api/pubsub';
let $25943768104c0291$var$pubsubClientPromise;
const $25943768104c0291$var$getPubSubDevUrl = ()=>{
    if (window.location.hostname === 'localhost' && true) {
        // In dev mode this allows the local dev proxy to use the WebSocket host
        // that matches the backend origin host. The __backendOriginHost is only
        // available with local dev server.
        const host = window.__backendOriginHost;
        return new URL('/gateway/wss/fps', `wss://${host}`);
    }
    return undefined;
};
const $25943768104c0291$export$45a69314cf48a3eb = ({ url: url, analyticsClient: analyticsClient })=>{
    return {
        product: $25943768104c0291$var$CONFLUENCE_PRODUCT_KEY,
        url: url,
        apsProtocol: {
            enabled: true,
            url: $25943768104c0291$var$getPubSubDevUrl()
        },
        analyticsClient: analyticsClient
    };
};

const $25943768104c0291$export$d77c15f0d624f8d2 = ()=>{
    return (0, $ge2sX.getSessionData)().then(async ({ cloudId: cloudId, activationId: activationId })=>{
        const analyticsClient = await (0, $04e9M.getAnalyticsWebClient)();
        const config = $25943768104c0291$export$45a69314cf48a3eb({
            url: $25943768104c0291$var$PUBSUB_HOST,
            analyticsClient: analyticsClient
        });
        return (parcelRequire("fElp9")).then((module)=>{
            const Client = module.default;
            return new (0, $7S9uM.PubSubClient)(new Client(config), cloudId, activationId);
        }).catch((error)=>{
            throw new Error(`PubSub--Current Web Client ${error}, ${JSON.stringify({
                ...config
            })}`);
        });
    });
};
const $25943768104c0291$export$e390a4d8bc17ac24 = ()=>{
    if ($25943768104c0291$var$pubsubClientPromise) return $25943768104c0291$var$pubsubClientPromise;
    $25943768104c0291$var$pubsubClientPromise = $25943768104c0291$export$d77c15f0d624f8d2();
    return $25943768104c0291$var$pubsubClientPromise;
};
module.exports["getPubSubClient"] = $25943768104c0291$export$e390a4d8bc17ac24;

});

parcelRegister("fElp9", function(module, exports) {

let $b64b31fc15bf72b3$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $b64b31fc15bf72b3$var$load("9kKls"),
    $b64b31fc15bf72b3$var$load("4LRGx"),
    $b64b31fc15bf72b3$var$load("gqQUS")
]).then(()=>parcelRequire('cGljI'));

});

parcelRegister("6dFT0", function(module, exports) {
"use strict";


let $487472ade577be65$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("clX3F")).shardUrl((parcelRequire("1hiTA")).resolve(id), maxShards));
    };
module.exports = $487472ade577be65$var$load;

});

parcelRegister("clX3F", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.applyShardToDomain = $8fe541edd234eb0b$var$applyShardToDomain;
module.exports.domainShardingKey = void 0;
module.exports.getDomainShardIndex = $8fe541edd234eb0b$var$getDomainShardIndex;
module.exports.shardUrl = $8fe541edd234eb0b$var$shardUrl;
module.exports.shardUrlUnchecked = $8fe541edd234eb0b$var$shardUrlUnchecked;
const $8fe541edd234eb0b$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 */ function $8fe541edd234eb0b$var$getFilenameFromUrlPath(pathname) {
    const lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 */ function $8fe541edd234eb0b$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    const totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        const n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
const $8fe541edd234eb0b$var$trailingShardRegex = /-\d+$/;
/**
 * Removes trailing shard number from subdomain
 */ function $8fe541edd234eb0b$var$removeTrailingShard(subdomain) {
    if (!$8fe541edd234eb0b$var$trailingShardRegex.test(subdomain)) return subdomain;
    const shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 */ function $8fe541edd234eb0b$var$applyShardToDomain(domain, shard) {
    const i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    const shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$8fe541edd234eb0b$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    const firstSubdomain = $8fe541edd234eb0b$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 */ function $8fe541edd234eb0b$var$shardUrlUnchecked(url, maxShards) {
    const parsedUrl = new URL(url);
    const fileName = $8fe541edd234eb0b$var$getFilenameFromUrlPath(parsedUrl.pathname);
    const shardNumber = $8fe541edd234eb0b$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $8fe541edd234eb0b$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 */ function $8fe541edd234eb0b$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$8fe541edd234eb0b$var$globalKeyName]) return url;
    return $8fe541edd234eb0b$var$shardUrlUnchecked(url, maxShards);
}
const $8fe541edd234eb0b$var$domainShardingKey = module.exports.domainShardingKey = $8fe541edd234eb0b$var$globalKeyName;

});

parcelRegister("1hiTA", function(module, exports) {
$parcel$export(module.exports, "register", () => $0ee60939fdb4dc28$export$6503ec6e8aabbaf, (v) => $0ee60939fdb4dc28$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $0ee60939fdb4dc28$export$f7ad0328861e2f03, (v) => $0ee60939fdb4dc28$export$f7ad0328861e2f03 = v);
var $0ee60939fdb4dc28$export$6503ec6e8aabbaf;
var $0ee60939fdb4dc28$export$f7ad0328861e2f03;
"use strict";
var $0ee60939fdb4dc28$var$mapping = new Map();
function $0ee60939fdb4dc28$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$0ee60939fdb4dc28$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $0ee60939fdb4dc28$var$resolve(id) {
    var resolved = $0ee60939fdb4dc28$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$0ee60939fdb4dc28$export$6503ec6e8aabbaf = $0ee60939fdb4dc28$var$register;
$0ee60939fdb4dc28$export$f7ad0328861e2f03 = $0ee60939fdb4dc28$var$resolve;

});

parcelRegister("bT0se", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $5ZqQS = parcelRequire("5ZqQS");


var $3IBnw = parcelRequire("3IBnw");


var $04e9M = parcelRequire("04e9M");


var $bQm3c = parcelRequire("bQm3c");


var $d9tcB = parcelRequire("d9tcB");


var $gRrX4 = parcelRequire("gRrX4");


var $7S9uM = parcelRequire("7S9uM");

const $521819119d35ee54$export$2612561ece05d878 = [
    '401',
    'Failed to fetch',
    'Load Failed',
    'Network error'
];
const $521819119d35ee54$var$isIgnoredPubSubError = (error)=>{
    return $521819119d35ee54$export$2612561ece05d878.some((errorString)=>error?.message.includes(errorString));
};
const $521819119d35ee54$export$eee20638634729b3 = (eventName, onEvent)=>{
    return (...args)=>{
        onEvent(...args);
        (0, $04e9M.getAnalyticsWebClient)().then((client)=>{
            client.sendOperationalEvent({
                action: 'received',
                actionSubject: 'pubsub.event',
                actionSubjectId: eventName,
                source: 'usePubSubEvent'
            });
        }, ()=>{});
    };
};
const $521819119d35ee54$export$db1c585708735fff = ({ contentId: contentId, contentType: contentType, eventName: eventName, onEvent: onEvent, attribution: attribution, skip: skipProp = false })=>{
    const [pubSubClient, setPubSubClient] = (0, $cozmU.useState)(undefined);
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    // if user is anonymous, skip
    const skip = accessStatus === (0, $d9tcB.AccessStatus).ANONYMOUS_ACCESS || skipProp;
    (0, $cozmU.useEffect)(()=>{
        if (skip || !contentId || !contentType) return;
        const pubSubPromise = new Promise((resolve)=>{
            (0, $gRrX4.getPubSubClient)().then((psc)=>{
                psc.joinChannel(contentType, contentId).then(()=>{
                    setPubSubClient(psc);
                    // Temporarily fire events when PubNub protocol is detected
                    // to investigate source of requests
                    if ((0, $7S9uM.getCurrentProtocolType)(psc.client) === 'pubnub') {
                        const { analyticsClient: analyticsClient, ...config } = psc.client?.config;
                        // copy config obj so we can scrub URL from logs
                        const configCopy = JSON.parse(JSON.stringify(config));
                        delete configCopy.apsProtocol?.url;
                        // eslint-disable-next-line @typescript-eslint/no-floating-promises -- Analytics logging is intentionally fire-and-forget
                        (0, $04e9M.getAnalyticsWebClient)().then((client)=>{
                            client.sendOperationalEvent({
                                action: 'using.pubnub',
                                actionSubject: 'client',
                                source: 'usePubSubEvent',
                                attributes: {
                                    contentId: contentId,
                                    contentType: contentType,
                                    config: configCopy
                                }
                            });
                        });
                    }
                    resolve(psc);
                }).catch((error)=>{
                    if (!$521819119d35ee54$var$isIgnoredPubSubError(error)) {
                        const e = new Error(`PubSub (${(0, $7S9uM.getCurrentProtocolType)(psc.client)}) - failed to join channel - ${error} - ${eventName}`);
                        (0, $5ZqQS.getMonitoringClient)().submitError(e, {
                            attribution: attribution || (0, $3IBnw.Attribution).PAGE_EXTENSIONS
                        });
                    }
                });
            });
        });
        return ()=>{
            pubSubPromise.then((psc)=>{
                setPubSubClient(undefined);
                psc.leaveChannel(contentType, contentId);
            });
        };
    }, [
        contentType,
        contentId,
        attribution,
        skip,
        eventName
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (!pubSubClient) return;
        const avi = (0, $7S9uM.eventToAvi)(eventName);
        const eventHandler = $521819119d35ee54$export$eee20638634729b3(avi, onEvent);
        try {
            pubSubClient.subscribeSync(avi, eventHandler);
        } catch (error) {
            const e = new Error(`PubSub (${(0, $7S9uM.getCurrentProtocolType)(pubSubClient.client)}) - failed to subscribe to ${eventName} - ${error}`);
            (0, $5ZqQS.getMonitoringClient)().submitError(e, {
                attribution: attribution || (0, $3IBnw.Attribution).PAGE_EXTENSIONS
            });
        }
        return ()=>{
            pubSubClient.unsubscribeSync(avi, eventHandler);
        };
    }, [
        pubSubClient,
        eventName,
        onEvent,
        attribution
    ]);
};
module.exports["usePubSubEvent"] = $521819119d35ee54$export$db1c585708735fff;

});


//# sourceMappingURL=vendors~small-pkgs.17eeb426.js.map
